module.exports = __webpack_public_path__ + "static/media/faq-1.018d4104.png";